import styled from "styled-components";
import { ContainerSection } from "@/main/components/shared/styles";

export const Container = styled(ContainerSection)`
	display: flex;
	flex-direction: row;
	gap: 1rem;
`;

export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 0.4rem;
	width: 100%;
`;

export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;

export const AreaForm = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1rem;
	margin: 0 0 50px 0;

	@media (max-width: 768px) {
		display: flex;
		flex-direction: column;
	}
`;

export const ContainerColor = styled(Container)`
	flex-direction: column;
	background-color: white;
	justify-content: center;
	align-items: center;
	gap: 0;
	margin-bottom: 0;
`;

export const ContainerImage = styled.div`
	width: 100%;
	grid-column: 1/3;
`;
